var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content_loaded)?_c('div',{class:[_vm.classes],attrs:{"data-cy":"static_content"},domProps:{"innerHTML":_vm._s(_vm.html_content)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }